import { ButtonAccessability } from "components/Elements/Button/Button";
import Icon from "components/Elements/Icon/Icon";
import React, { useEffect } from "react";

interface ICollapseButton {
  setCurrentOption: React.Dispatch<React.SetStateAction<string | null>>;
  collapsed: boolean;
}

const CollapseButton = ({ setCurrentOption, collapsed }: ICollapseButton) => {
  const handleChangeCurrentOption = () => {
    setCurrentOption((prev) => (!prev ? "send-plane" : null));
  };

  return (
    <ButtonAccessability
      className="collapse-button"
      onClick={handleChangeCurrentOption}
      type="button"
    >
      <Icon name={collapsed ? "hamburger" : "arrow-right"} gray />
    </ButtonAccessability>
  );
};

export default CollapseButton;
